import React from 'react';

import { AsaphAvatar } from '@/components/shared/Avatar';
import { BaseChatCard } from '@/components/shared/ChatCard';
import { LinkFrom, unknownDisplayName } from '@/config/constants';
import { videoUrl } from '@/config/urls';
import { ListTeamVideoChatsQuery } from '@/graphql';
import { getTimePassedAfterTimestamp } from '@/helpers/timeFormatter';
import { last } from 'ramda';

interface ChannelsCardProps {
	chat: ListTeamVideoChatsQuery['listTeamVideoChats'][number];
	isUnread?: boolean;
}

export const ChannelsCard: React.FC<ChannelsCardProps> = ({
	chat,
	isUnread,
}) => {
	const lastMessage = last(chat?.messages?.items || []);

	return (
		<BaseChatCard
			{...{
				image: (
					<AsaphAvatar
						size="small"
						name={chat.video?.name ?? ''}
						src={chat.video?.thumbnailUrl}
						isRectangular
					/>
				),
				link:
					chat.video?.id &&
					`${videoUrl.replace(':token', chat.video.id)}`,
				title: chat.video?.name,
				messageText: lastMessage?.content || 'No messages yet',
				lastMessageAuthor:
					lastMessage?.user?.displayName || unknownDisplayName,
				recipientName: 'Test',
				dateSubtitle: getTimePassedAfterTimestamp(
					lastMessage?.createdAt || 'No chat yet',
				),
				linkFrom: LinkFrom.messages,
				linkComponentProp: true,
				hasNotification: isUnread,
			}}
		/>
	);
};
